<template>
  <GcBaseLayout
    :title="title"
    :isXSmall="isXSmall"
    :isLarge="isLarge"
    :baseView="baseView"
    :key="pageKey"
    :backButtonEnable="false"
    :formsConfig="formsConfig"
  >
    <gc-barcode-parser @barcodeScanned="barcodeScanned" />
    <template #headerContent>
      <GcHeaderContentStatic
        :title="screenConfig.title"
        class="roam-transaction-list-title"
      />
    </template>

    <GcDataGrid
      :grouping="true"
      :export="true"
      :summary="true"
      :id="'roam-transaction-list-grid'"
      ref="roamTransactionListGrid"
      :isLocalDataSource="false"
      :isEditableGrid="false"
      :showFooter="false"
      :dataSourceConfig="screenConfig.gridData.gridOptions.dataSource"
      :columns="screenConfig.gridData.columns"
      :gridOptions="screenConfig.gridData.gridOptions"
      :gridToolbar="screenConfig.gridData.toolbar"
      :exportFileName="screenConfig.exportFileName"
      v-if="loaded"
      class="roam-transaction-list"
      :rowClick="rowClickCallBack"
      :persistenceKey="persistenceKey"
    />

    <GcPopup
      :popup-visible="popupVisible"
      :popup-title="popupTitle"
      :back-button-function="popUpBackButtonClick"
      :fullScreen="true"
      :showTitle="popUpShowTitle"
      :saveButtonConfig="popUpConfig.save"
      v-if="popUpDataModel && popupVisible"
      :backButtonConfig="{ text: 'Cancel' }"
    >
      <GcForm
        :formOptions="popUpFormOptions"
        :formItems="popUpFormItems"
        :isNormal="true"
        :data-model="popUpFormDataModel"
        :formMode="popUpFormMode"
        v-if="popUpFormPopupItems"
      ></GcForm>
    </GcPopup>
  </GcBaseLayout>
</template>

<script>
import RouteMixin from "@/_mixins/route.mixin";
import FormMixin from "@/_mixins/form.mixin";
import { RoamTransactionListService } from "../../_services/api/templates/roam-transactions-list.services";
import { CacheService } from "../../_services/cache/cache-service";
export default {
  mixins: [RouteMixin, FormMixin],
  props: {
    persistenceKey: {
      type: String,
    },
    screenConfig: {
      type: Object,
      default: undefined,
    },
    rowClick: {
      type: Function,
      default: () => {},
    },
    barcodeScanned: {
      type: Function,
      default: () => {},
    },
    setLoading: {
      type: Boolean,
      default: false,
    },
    popupVisible: {
      type: Boolean,
      default: false,
    },
    isXSmall: Boolean,
    isLarge: Boolean,
    // formsConfig: Object
    popUpBackButtonClick: {
      type: Function,
      default: () => {},
    },
    popUpConfig: {
      type: Object,
      default: undefined,
    },
    popUpFormItems: {
      type: Array,
      default: undefined,
    },
    popUpFormDataModel: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      loaded: false,
      popupTitle: "NONE",
      popUpShowTitle: false,
      // popUpSaveButtonConfig: {},
      popUpDataModel: {},
      popUpFormOptions: {
        gcLabelLocation: "left",
      },
      popUpFormPopupItems: [],
      // popUpFormDataModel: {},
      popUpFormMode: "create",
    };
  },
  beforeDestroy() {
    this.loaded = false;
  },

  async created() {
    if (this.screenConfig.ScreenName) this.getReportPreviewScreenName();
    else this.loaded = true;
  },
  methods: {
    // popupBackButtonClick() {
    //   this.popupVisible = false;
    // },
    async getReportPreviewScreenName() {
      var data = [];

      if (CacheService.getCache("ReportPreviewScreens")) {
        data = CacheService.getCache("ReportPreviewScreens").filter(
          (x) => x.ScreenName == this.screenConfig.ScreenName
        );
      } else {
        await RoamTransactionListService.getReportPreviewScreens()
          .then((res) => {
            CacheService.saveCache("ReportPreviewScreens", res.data.value, 5);
            data = res.data.value.filter(
              (x) => x.ScreenName == this.screenConfig.ScreenName
            );
          })
          .catch((err) => {
            if (err) this.getReportBackgroundScreenName();
          });
      }

      var index = this.screenConfig.gridData.columns.findIndex(
        (x) => x.screenField == "GridRecordPDFView"
      );
      if (index != -1) {
        let pdfPreviewData = data.filter(
          (x) => x.AvailableForPDFPreview == "Y"
        );
        this.screenConfig.gridData.columns[index].PrintPreview = pdfPreviewData;
        if (pdfPreviewData.length == 0)
          this.screenConfig.gridData.columns[index].visible = false;
      }

      var emailColumnIndex = this.screenConfig.gridData.columns.findIndex(
        (x) => x.screenField == "GridRecordEmail"
      );

      if (emailColumnIndex != -1) {
        let emailData = data.filter((x) => x.AvailableForEmail == "Y");

        this.screenConfig.gridData.columns[
          emailColumnIndex
        ].BackgroundEmail = emailData;
        if (emailData.length == 0)
          this.screenConfig.gridData.columns[emailColumnIndex].visible = false;
      }

      this.getReportBackgroundScreenName();
    },
    async getReportBackgroundScreenName() {
      var data = [];

      if (CacheService.getCache("ReportBackgroundScreens")) {
        data = CacheService.getCache("ReportBackgroundScreens").filter(
          (x) => x.ScreenName == this.screenConfig.ScreenName
        );
      } else {
        await RoamTransactionListService.getReportBackgroundScreens({
          select: [
            "RecordID",
            "ReportDisplayName",
            "ScreenName",
            "Status",
            "TransactionCode",
          ],
        })
          .then((res) => {
            CacheService.saveCache(
              "ReportBackgroundScreens",
              res.data.value,
              5
            );
            data = res.data.value.filter(
              (x) => x.ScreenName == this.screenConfig.ScreenName
            );
          })
          .catch((err) => {
            if (err) this.loaded = true;
          });
      }

      var index = this.screenConfig.gridData.columns.findIndex(
        (x) => x.screenField == "GridRecordPrint"
      );
      if (index != -1) {
        this.screenConfig.gridData.columns[index].BackgroundPrint = data;
        if (data == 0)
          this.screenConfig.gridData.columns[index].visible = false;
      }

      this.loaded = true;
    },
    backButtonFunction() {},

    rowClickCallBack(e) {
      if (!e.data) return;
      if (this.screenConfig.gridData.gridOptions.rowSelect)
        this.onRowClicked(e, this.screenConfig.gridData.gridOptions.rowSelect);
      else this.rowClick(e);
    },
  },
  watch: {
    setLoading(val) {
      this.showLoading(val);
    },
    // popupVisible(val) {
    //   console.log("popupVisible ", val);
    //   if(val) {
    //     // this.popUpFormPopupItems = this.popUpConfig.formItems;
    //     // this.popUpSaveButtonConfig = this.popUpConfig.save;
    //     this.popUpFormMode = 'create';
    //     // this.popUpFormDataModel = this.popUpConfig.formDataModel;
    //   }
    // },
  },
};
</script>

<style lang="scss">
.roam-transaction-list {
  .dx-datagrid-header-panel .dx-toolbar-items-container {
    height: 65px;
  }
}

.roam-transaction-list-title {
  text-align: left;
}
</style>
